var Disability = /* @__PURE__ */ ((Disability2) => {
  Disability2["WHEELCHAIR_USER"] = "WHEELCHAIR_USER";
  return Disability2;
})(Disability || {});
var DisabilityCardLevel = /* @__PURE__ */ ((DisabilityCardLevel2) => {
  DisabilityCardLevel2["NONE"] = "none";
  DisabilityCardLevel2["DISABLED_PERSON"] = "disabledPerson";
  DisabilityCardLevel2["LEGALLY_BLIND"] = "legallyBlind";
  DisabilityCardLevel2["THIRD_PARTY_NEEDED"] = "thirdPartyNeeded";
  return DisabilityCardLevel2;
})(DisabilityCardLevel || {});
export {
  Disability,
  DisabilityCardLevel
};
